import { Component, OnInit } from '@angular/core';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.sass']
})
export class RegisterComponent implements OnInit {

  public viewSession;
  public subscriber:string;
  public accountType:string;
  public accountSubType:string;
  public txtType;
  public ssn:string;
  public email:string;
  public securityCode:string;
  constructor(public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Registro");
    this.AngularFireAnalytics.logEvent("Registro-Screenview");
  }
  ngOnInit() {
      this.viewSession=1;
  }
}
